import { forwardRef, useEffect, useImperativeHandle } from 'react';
import { AudioPauseIcon } from '@/app/components/icons/AudioPauseIcon';
import { AudioPlayIcon } from '@/app/components/icons/AudioPlayIcon';
import { Slider } from '@/app/components/ui/slider';
import { useAudioPlay } from '@/app/hooks';
import { formatTime } from '@/app/utils';

interface AudioPlayerProps {
  url: string;
  id: string;
  duration: number;
  onPlay: (id: string | null) => void;
}

export type AudioPlayerRef = {
  handlePlayPause: () => void;
};

export const AudioPlayer = forwardRef<AudioPlayerRef, AudioPlayerProps>(({ url, id, duration, onPlay }, ref) => {
  const { isPlaying, progress, handlePlayPause, setProgress } = useAudioPlay({ url, id });

  useImperativeHandle(ref, () => ({
    handlePlayPause,
  }));

  const handleSliderChange = (values: number[]) => {
    if (values.length > 0) {
      setProgress(values[0]);
    }
  };

  useEffect(() => {
    onPlay(isPlaying ? id : null);
  }, [isPlaying]);

  return (
    <div className="flex items-center gap-6 md:gap-3" onClick={(e) => e.stopPropagation()}>
      <span className="font-normal text-sm text-white/40">{formatTime(progress)}</span>

      <Slider
        value={[progress]}
        max={duration}
        step={0.01}
        className="flex-1"
        onValueChange={handleSliderChange}
        style={{
          // @ts-expect-error
          '--slider-track-color': 'rgba(255, 255, 255, 0.12)',
        }}
      />

      <span className="h-6 w-12 shrink-0 cursor-pointer text-white" onClick={handlePlayPause}>
        {isPlaying ? <AudioPauseIcon className="h-full w-full" /> : <AudioPlayIcon className="h-full w-full" />}
      </span>
    </div>
  );
});
